import { UtilityService } from "../../../services/utility.service";
import { Toro } from "../../common/enumerations";

export class LpcuDetailsLpcuStatus {
    constructor(json: any = null) {
        if (json) {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);

            if (json.Date) this.Date = new Date(json.Date);
        }
    }

    Date: Date;
    BootVersion: number;
    DawnOffset: number;
    DuskOffset: number;
    FirmwareVersion: number;
    HardwareVersion: number;
    IsOn: boolean;
    ShortId: number;
    Temperature: number;
    UseDaylightSavings: boolean;
    UtcOffset: number;
    Version: number;
    WKD_A: number;
    WKD_B: number;

    ScheduleAOnTimeOption: Toro.TimeOption;
    ScheduleAOnTimeHour: number;
    ScheduleAOnTimeMinute: number;
    ScheduleAOffTimeOption: Toro.TimeOption;
    ScheduleAOffTimeHour: number;
    ScheduleAOffTimeMinute: number;
    ScheduleAOnTimeOption2: Toro.TimeOption;
    ScheduleAOnTimeHour2: number;
    ScheduleAOnTimeMinute2: number;
    ScheduleAOffTimeOption2: Toro.TimeOption;
    ScheduleAOffTimeHour2: number;
    ScheduleAOffTimeMinute2: number;
    ScheduleBOnTimeOption: Toro.TimeOption;
    ScheduleBOnTimeHour: number;
    ScheduleBOnTimeMinute: number;
    ScheduleBOffTimeOption: Toro.TimeOption;
    ScheduleBOffTimeHour: number;
    ScheduleBOffTimeMinute: number;
    ScheduleBOnTimeOption2: Toro.TimeOption;
    ScheduleBOnTimeHour2: number;
    ScheduleBOnTimeMinute2: number;
    ScheduleBOffTimeOption2: Toro.TimeOption;
    ScheduleBOffTimeHour2: number;
    ScheduleBOffTimeMinute2: number;

    // Inspira Details
    FixtureType: number;
    RepeatMode: number;
    LastCommunicationType: string;
    StatusReportInterval: number;
    ActiveTheme: string;
    CurrentBeamSpreadIndex: number;
    CurrentCoolIndex: number;
    CurrentDimmingIndex: number;
    CurrentRIndex: number;
    CurrentGIndex: number;
    CurrentBIndex: number;
    CurrentWarmIndex: number;
    LightStatus:string;
    CurrentRGBIndex:string;

    get UseDaylightSavingsString(): string {
        return this.UseDaylightSavings ? "Auto" : "Off";
    }

    get temperatureString(): string {
        return `${this.Temperature * 1.8 + 32} F   (${this.Temperature} C)`;
    }

    get outletStatus(): string {
        return this.IsOn ? "On" : "Off";
    }

    getScheduleStartStop(lpcuSchedule: Toro.LpcuSchedule, index: number) {
        const schedule = lpcuSchedule === Toro.LpcuSchedule.A ? "A" : "B";
        const option = index === 1 ? "" : "2";

        const scheduleOnOption =
            this[`Schedule${schedule}OnTimeOption${option}`];
        const scheduleOnTimeHour =
            this[`Schedule${schedule}OnTimeHour${option}`];
        const scheduleOnTimeMinute =
            this[`Schedule${schedule}OnTimeMinute${option}`];
        const scheduleOffOption =
            this[`Schedule${schedule}OffTimeOption${option}`];
        const scheduleOffTimeHour =
            this[`Schedule${schedule}OffTimeHour${option}`];
        const scheduleOffTimeMinute =
            this[`Schedule${schedule}OffTimeMinute${option}`];

        if (scheduleOnOption === Toro.TimeOption.Disable) return "disabled";

        return `${this.getTimeValue(
            scheduleOnOption,
            scheduleOnTimeHour,
            scheduleOnTimeMinute
        )} - \
                ${this.getTimeValue(
                    scheduleOffOption,
                    scheduleOffTimeHour,
                    scheduleOffTimeMinute
                )}`;
    }

    getScheduleDays(lpcuSchedule: Toro.LpcuSchedule): string {
        const schedule = lpcuSchedule === Toro.LpcuSchedule.A ? "A" : "B";
        const daysByte = this[`WKD_${schedule}`];
        let days = "";

        if (daysByte === 0) return "";

        for (const dayFlagKey in Toro.DayFlag) {
            if (!isNaN(+dayFlagKey) && (daysByte & +dayFlagKey) !== 0) {
                if (days.length > 0) days += ", ";
                days += Toro.DayFlag[+dayFlagKey];
            }
        }

        return days;
    }

    // =========================================================================================================================================================
    // Helper Methods
    // =========================================================================================================================================================

    private getTimeValue(
        scheduleOption: Toro.TimeOption,
        hours: number,
        minutes: number
    ) {
        switch (scheduleOption) {
            case Toro.TimeOption.Disable:
                return "disabled";
            case Toro.TimeOption.Dawn:
                return "Dawn";
            case Toro.TimeOption.Dusk:
                return "Dusk";
            default:
                return `${hours % 12}:${UtilityService.pad(minutes, 2)} ${
                    hours < 12 ? "am" : "pm"
                }`;
        }
    }
}
